// import { gatewayClient } from 'boot/axios'
import businessClient from 'src/services/clients/business'
import {
  // IServerNames,
  IMeta,
  ISquareResource,
  ILocations,
} from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: { url: '' } }
const ICatalogResponse = { meta: IMeta, data: { data: '' } }
const ISquareResourceResponse = { meta: IMeta, data: [ISquareResource] }
const ILocationsResponse = { meta: IMeta, data: [ILocations] }

export const integrationSquare = {
  /**
   * @param {{ filter:object, data: object }} object
   * @return {Promise<ILocationsResponse>}
   */
  locationsList(object) {
    return businessClient().post('square/locations/portal/list', object)
  },

  /**
   * @param {{ id:number, store_id:number }} data
   * @return {Promise<ILocationsResponse>}
   */
  updateLocations(data) {
    return businessClient().post('square/locations/update', { data })
  },

  /**
   * @param {{redirect_url: string}} data
   * @return {Promise<IResponse>}
   */
  getUrl(data) {
    return businessClient().post('square/integration/get-url', { data })
  },

  /**
   *  @param {{ filter:object, data: object }} data
   * @return {Promise<ICatalogResponse>}
   */
  getCatalog(data = { filter: {}, data: {} }) {
    return businessClient().post('square/integration/get-catalog', {
      data,
    })
  },

  /**
   * @param {{type: string}} filter
   * @return {Promise<ISquareResourceResponse>}
   */
  getResource(filter) {
    return businessClient().post('resources/front-data/get', { filter })
  },

  /**
   * @param {ISquareResource} data
   * @return {Promise<ISquareResourceResponse>}
   */
  setResource(data) {
    return businessClient().post('resources/front-data/set', { data })
  },

  /**
   * @return {Promise<ISquareResourceResponse>}
   */
  connectedItems() {
    return businessClient().post('square/integration/connected-items/count', {})
  },

  /**
   * @return {Promise<ISquareResourceResponse>}
   */
  disconnect() {
    return businessClient().post('square/integration/disconnect', {})
  },
}
